// OAuth https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=6849518
export const HOST = ['https://ams-auth-us-test.tigerbrokers.net', 'https://oauth.tradeup.com'];
export const API = {
    origin: '',
    // wiki: https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=20619356 @任建军
    userinfo: '/api/v1/user/info', // 用户信息
    signout: '/api/v1/auth/signout', // 登出
    signin: '/api/v1/auth/signin', // 登录
    signup: '/api/v1/auth/signup', // 注册
    tradeAuth: '/auth/trade/authorize', // 交易token
    modifyTradePwd: '/auth/trade/modify', // 修改交易密码
    captcha: '/api/v1/verification/captcha', // 图片验证码
    /**
     * 验证码登录
     * https://apidocs.tigerfintech.com/repository/27/api/master/reference/app-web.json#/operations/post--api-v1-auth-verify_code-signin
     * RD: wangzhengyang
     */
    signinWithCode: '/api/v1/auth/verify_code/signin',

    emailCode: '/api/v1/verification/send/email',
    phoneCode: '/api/v1/verification/send/phone',

    // 安全设置
    setphone: '/api/v1/security/set/phone', // 设置手机号（开户过程中）
    setEmail: '/api/v1/security/set/email', // 设置邮箱（开户过程中）

    // 绑定账户
    bindPhone: '/api/v1/security/bind/phone', // 绑定手机号
    bindEmail: '/api/v1/security/bind/email', // 绑定邮箱

    // put  密码修改,修改邮箱，手机号
    // 接口文档：https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=20613322
    modifyLoginPassword: '/api/v1/security/modify/login_password', // 修改登录密码
    modifyTradePassword: '/api/v1/security/modify/trade_password', // 修改交易密码
    modifyEmail: '/api/v1/security/modify/email',
    modifyPhone: '/api/v1/security/modify/phone',

    // post
    resetLoginPassword: '/api/v1/security/reset/login_password', // 重置登陆密码
    resetTradePassword: '/api/v1/security/reset/trade_password', // 重置交易密码

    // 身份验证
    verifyPassword: '/api/v1/verification/verify/password', // 验证登录或者交易密码
    verifyOptions: '/api/v1/verification/verify/options', // 获取验证方法

    // 三种验证方法
    verifyOtp: '/api/v1/verification/verify/otp', // 验证TradeUP Authenticator
    verifyPhoneCode: '/api/v1/verification/verify/phone', // 验证手机验证码
    verifyEmailCode: '/api/v1/verification/verify/email', // 验证手机验证码

    // 两步验证相关接口
    otp: {
        // 关闭两步验证
        off: '/api/v1/otp/switch/off',
        genkey: '/api/v1/otp/genkey',
        on: '/api/v1/otp/switch/on',
        status: '/api/v1/otp/status',
        setting: '/api/v1/otp/setting'
    },

    // 极验证 https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=41713682#3
    geeRegister: '/api/v1/verification/captcha/register', // 极验证注册

    // https://apidocs.tigerfintech.com/repository/27?branch=master&type=api&uri=reference%2Fapp-web.json#/operations/get--api-v1-verification-captcha-init @刘杨
    captchaInit: '/api/v1/verification/captcha/init',

    // 验证 recaptcha token 是否有效
    // https://apidocs.tigerfintech.com/repository/27?branch=master&type=api&uri=reference%2Fapp-web.json#/operations/post-api-v1-verification-captcha-post
    verifyCaptcha: '/api/v1/verification/captcha/recaptcha',

    // 验证极验 token https://apidocs.tigerfintech.com/repository/27/api/master/reference/app-web.json#/operations/post-api-v1-verification-captcha-geetest4 @刘杨
    verifyGee: '/api/v1/verification/captcha/geetest4',

    /**
     * 注销/删除账户
     * @huangcong
     * https://apidocs.tigerfintech.com/repository/83/markdown/master/docs/%E7%94%A8%E6%88%B7%E6%9C%8D%E5%8A%A1%E6%80%BB%E8%A7%88.md
     */
    delete: {
        // https://apidocs.tigerfintech.com/repository/83/api/master/APIs/profile.json#/operations/get-api-v1-user-cancellation
        cancellation: '/user/api/v1/user/cancellation', // GET 查询注销状态; POST 提交注销请求/撤销注销申请
        // https://apidocs.tigerfintech.com/repository/83/api/master/APIs/profile.json#/operations/get-api-v1-user-cancellation-check
        checkCancel: '/user/api/v1/user/cancellation/check', // 检查是否可以注销，并返回相应理由
        // https://apidocs.tigerfintech.com/repository/83/api/master/APIs/profile.json#/operations/post-api-v1-user-cancellation-apply
        apply: '/user/api/v1/user/cancellation/apply', // 提交申请
        // https://apidocs.tigerfintech.com/repository/83/api/master/APIs/profile.json#/operations/post-api-v1-user-cancellation-revoke
        revoke: '/user/api/v1/user/cancellation/revoke' // 撤回注销申请
    },

    // 邀请码 https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=20619356
    invitation: {
        list: '/api/v1/user/invitation' // get method
    },

    // 查询用户的三方账号绑定信息: https://apidocs.tigerfintech.com/repository/27/api/master/reference/app-web.json#/operations/get-api-v1-sns-info
    getSnsInfo: '/api/v1/sns/info',
    userSetting: '/api/v1/user/settings', // 用户设置信息

    modify: {
        verifyOptions: '/api/v1/verification/verify/options', // 获取验证方式
        verifySetting: '/api/v1/verification/verify/:type', // 验证手机验证码,验证邮箱 (phone | email)
        modifySetting: '/api/v1/security/modify/:type', // 修改手机号,邮箱 (phone | email | login_password)
        // https://team.tigerfintech.com/ams/docs/Auth/index#req_6d7fd4fb203b49e590d24693c0a63a27
        verifyIdNo: '/api/v1/verification/verify/id_no' // 身份证件号码验证
    },

    // 接口参数返回值同/api/v1/security/modify/login_password
    updatePassword: '/api/v1/security/update/login_password',
    // 设置密码 https://apidocs.tigerfintech.com/repository/27/api/master/reference/app-web.json#/operations/post--api-v1-security-set-login_password
    setPassword: '/api/v1/security/set/login_password',
    /**
     * https://apidocs.tigerfintech.com/repository/27/api/master/reference/app-web.json#/operations/post--api-v1-auth-trade-authorize
     * 获取tradeToken
     */
    getTradeToken: '/api/v1/auth/trade/authorize'
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API['oauth-global']?.GLOBAL || (CG_API['oauth-global'] as any)?.COMMON;

    if (cfg) {
        HOST.fill(cfg);
    }
}
